import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import { rest } from "@/utilities/rest.js";

Vue.use(Vuex);

export default new Vuex.Store({

	plugins: [createPersistedState({
		storage: window.sessionStorage,
		reducer: state => ({
			studioId: state.studioId,
			planId: state.planId,
			referredBy: state.referredBy,
			profile: state.profile,
			remindCount: state.remindCount,
			stepsWatch: state.stepsWatch
		})
	})],

	modules: {
	},

	state: {

		// Step 1: The home location of a student
		studioId: null,

		// Step 2: The plan selected by the student
		planId: null,

		referredBy: null,

		disableProfileFields: false,

		// Step 3: The profile of the student and creation of user account if necessary
		// Password is not persisted in state
		profile: {
			userId: null,
			firstname: null,
			lastname: null,
			email: null,
			phone: null,
			aboutme: [],
			comments: null,
			createAccount: false
		},

		// Never passed through mutation method and therefore will never persist to session state
		payment: {
			method: "card",
			cardType: "",
			firstname: "",
			lastname: "",
			cardNumber: "",
			cardMonth: "",
			cardYear: "",
			cardCvv: "",
			cardZip: "",
			accountType: null,
			bankName: "",
			routingNumber: "",
			accountNumber: "",
			cardNumberReal: ""
		},

		stepsWatch: {
			current: 0,
			membership: {
				intro: true
			},
			payment: {
				intro: true
			}
		},

		remindCount: 0,
		
		
		locations: [
			
		],
		plans: {
			
		},
		steps: {},

		modals: {},

    terms: ""

	},

	getters: {

		stepsWatch: state => {
			return state.stepsWatch;
		},

		locations: state => {
			return state.locations;
		},

		plans: state => {
			return state.plans;
		},

		profile: state => {
			return state.profile;
		},

		selectedPlan: state => {
			return _.find(state.plans.plans, ["id", state.planId]);
		},

		selectedStudio: state => {
			return _.find(state.locations, ["id", state.studioId]);
		},

		payment: state => {
			return state.payment;
		},

		remindCount: state => {
			return state.remindCount;
		}
	},

	mutations: {
		setProfile(state, payload) {
			state.profile = payload;
		},
		setPlan(state, payload) {
			state.planId = payload;
		},
		setLocation(state, payload) {
			state.studioId = payload;
		},

		setReferral(state, payload) {
      state.referredBy = payload;
    },

		setStep(state, payload) {
			state.stepsWatch[payload.step][payload.prop] = payload.value;
			
		},

		incrementRemind(state) {
			++state.remindCount;
		}
	},

	actions: {

		
  }
})
